import React from "react";

import { AsyncSelect, IAsyncSelectProps } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import WorkTypesService from "@/services/WorkTypesService";

import { cn } from "@/utils/cn";

import { TWorkType } from "@/types";

export const WorkTypesSelect: React.FC<
	Partial<IAsyncSelectProps<TWorkType>>
> = (props) => {
	const fetchWorkTypes = () =>
		WorkTypesService.getWorkTypes().then((response) => {
			if (response.length === 1) {
				props.onChange?.(response[0]);
			}

			return response.map((workType: TWorkType) => ({
				value: workType,
				label: t(`workTypes.types.${workType.code}`),
			}));
		});

	return (
		<AsyncSelect
			loadOptions={fetchWorkTypes}
			isClearable={true}
			getOptionValue={(workType) => workType.code}
			{...props}
			className={cn(["w-full", props.className])}
			placeholder={props.placeholder || t("workTypes.select").toString()}
			label={props.label || t("workTypes.label").toString()}
		/>
	);
};
